import { useParams } from "react-router-dom";

export const useGetOrgData = () => {
  const params = useParams();
  const { sport, organizationId, customerId } = params;

  return { sport, organizationId, customerId };
};
